<template>
  <q-item v-bind="$attrs" @click="download">
    <q-item-section>
      <q-item-label>
        <p class="q-mb-sm"><strong>Album generated:</strong></p>
        <p class="q-mb-sm">{{ data.fileName }}</p>
        <p class="q-mb-none">Click here to download</p>
      </q-item-label>
      <q-item-label caption>
        <slot></slot>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface AlbumFileGenerated {
  reportId: number,
  fileName: string,
  fileUrl: string
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => AlbumFileGenerated,
      required: true,
    },
  },
  methods: {
    download() {
      window.open(this.data.fileUrl, '_blank');
    },
  },
});
</script>
